import React, { ChangeEvent } from 'react';
import { Box, Modal, Grid, Zoom, Checkbox, FormControlLabel } from '@mui/material';
import { BackdropLoading } from '../../../shared/spinner/backdropLoading';
import { CancelButton, CheckBoxContainer, ModalLabel, modalStyle, OkButton } from './jojoCondition.styles';
import { sessionDisconnectedCheck } from '../../../shared/api/sessionDisconnectedCheck';
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';
import { SearchCrudApiRequest } from '../../../shared/model/apiRequestModel';
import crud from '../../../shared/api/crud';
import { SystemErrorMsg, SystemErrorTitle } from '../../../constants';

interface OwnProps {
    isOpen: boolean,
    handleClose: (isOpen: boolean) => void
    handleOk: (value: DialogItemType[], operator: string) => void,
}

interface DialogItemType {
    id: string
    value: string
}

interface CodeList {
    id: string,
    value: string
}

interface Item {
    id: string,
    value: string
    checked: boolean
}

const screenId = "U043"

const JojoDialog = (props: OwnProps) => {
    const navigate = useNavigate();
    const { isOpen, handleClose } = props
    const [open, setOpen] = React.useState(isOpen);
    const [codeList, setCodeList] = React.useState<CodeList[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [items, setItems] = React.useState<Item[]>([])
    const [error, setError] = React.useState(false)

    const getJojoMaster = async () => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "getJojoMaster", navigate)) {
            return
        }
        setLoading(true)
        const session = await fetchAuthSession();
        const email = session.tokens?.idToken?.payload?.email?.toString() || '';
        const sessionId = session.tokens?.idToken?.payload?.sessionId?.toString() || '';
        const accountInfoData = JSON.parse(session.tokens?.idToken?.payload?.accountInfoData?.toString() || "[]");
        const contract = JSON.parse(session?.tokens?.idToken?.payload.contractInfoData?.toString() || "[]");
        const contractForm = contract.length !== 0 && contract[0].contractForm;
        const request: SearchCrudApiRequest = {
            sessionId: sessionId,
            userMailAddress: email,
            processFlag: "0",
            countFlag: "0",
            contractForm: contractForm,
            targetTableName: 'M_CODE',
            selectItems: ['CDSHBTCH', 'CDCH_IM'],
            conditions: [
                {
                    targetColumn: "SHBTCD",
                    targetValue: ['CD0023']
                }
            ],
            conditionsOperator: 'and',
            orderBy: [
                {
                    sortColumn: 'HYJ_JN',
                    sortRule: 'ASC',
                }
            ],
            usingStartDate: contract.length !== 0 && accountInfoData[0].usingStartDate
        }
        const response = crud(request);
        const resCd = (await response).resCd;
        if (resCd === 'I0000') {
            const codeList = (await response).data?.resultData.map((item: { CDSHBTCH: string; CDCH_IM: string; }) => {
                return { id: item.CDSHBTCH, value: item.CDCH_IM }
            })
            setCodeList(codeList);
            setLoading(false);
        } else {
            navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
        }
    };

    React.useEffect(() => {
        if (isOpen) {
            setError(false);
            if (codeList.length === 0) {
                getJojoMaster()
            } else {
                const items: Item[] = []
                codeList.map((v) => items.push({ id: v.id, value: v.value, checked: false }))
                setItems(items)
            }
        }
        setOpen(isOpen)
    }, [isOpen])

    React.useEffect(() => {
        const items: Item[] = []
        codeList.map((v) => items.push({ id: v.id, value: v.value, checked: false }))
        setItems(items)
    }, [codeList])

    const handleChange = (event: ChangeEvent<HTMLInputElement>, i: number) => {
        items[i].checked = event.target.checked
        setItems(items);
    };

    const handleOk = async () => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "jojoHandleOk", navigate)) {
            return
        }
        const checkedItems = items.filter((v) => v.checked === true)
        if (checkedItems.length === 0) {
            setError(true);
        } else {
            props.handleOk(checkedItems, "or")
        }
    }

    return (
        <>
            <BackdropLoading open={loading} />
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                sx={{
                    zIndex: 900
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            zIndex: 900
                        }
                    }
                }}
            >
                <Zoom
                    in={open}
                    style={{ zIndex: 1000, transformOrigin: '-50% -50% -50%' }}
                    easing={{
                        enter: "cubic-bezier(0, 1.45, 0.62, 1)",
                        exit: "linear"
                    }}
                >
                    <Box sx={modalStyle} tabIndex={-1}>
                        <ModalLabel>
                            選択条件 - 上場
                        </ModalLabel>
                        {
                            error ?
                                <Box sx={{ marginTop: '2%', marginBottom: '-2%', color: 'red', fontSize: '1.2rem' }}>   条件を一つ以上選択してください</Box>
                                :
                                <></>
                        }
                        <Box p={4}>
                            <CheckBoxContainer>
                                {codeList.map((v, i) => {
                                    return (
                                        <>
                                            <FormControlLabel
                                                sx={{ whiteSpace: "pre-wrap" }}
                                                label={v.id + "　" + v.value}
                                                control={<Checkbox onChange={(e) => handleChange(e, i)} />} /><br />
                                        </>
                                    )
                                })}
                            </CheckBoxContainer>
                        </Box>
                        <Box p={2} sx={{ marginTop: '-3%', marginBottom: '1%' }}>
                            <Grid container sx={{ width: '98%' }}>
                                <Grid size={7} />
                                <Grid size={5}>
                                    <CancelButton variant="contained" onClick={() => handleClose(false)}>キャンセル</CancelButton>
                                    <OkButton variant="contained" onClick={() => handleOk()}>OK</OkButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Zoom>
            </Modal >
        </>
    );
}

export default JojoDialog;
